<div
  *ngIf="showEditor()"
  (froalaInit)="initEditor($event)"
  [froalaEditor]="froalaOptions"
  [froalaModel]="_textValue"
  (froalaModelChange)="writeValue($event)"></div>
